// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimpleTable {
  position: relative;
}
.SimpleTable .SimpleTable-Header {
  position: relative;
  display: flex;
  flex-direction: column;
}
.SimpleTable .SimpleTable-Header .SimpleTable-Titlebar {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.SimpleTable .SimpleTable-Header .SimpleTable-Titlebar .SimpleTable-Title {
  background-color: var(--bs-secondary-subtle);
  padding: 0.5rem 1rem;
  border-radius: 0.85rem 0.85rem 0 0;
  text-transform: uppercase;
  font-weight: bold;
}
.SimpleTable .SimpleTable-Header *:not(.sticky) > .SimpleTable-Titlebar .SimpleTable-Shortcuts {
  flex-grow: 1;
}
.SimpleTable .SimpleTable-Header *:not(.sticky) > .SimpleTable-Titlebar .SimpleTable-Shortcuts span button {
  padding: 0.5rem 1rem;
}
.SimpleTable .SimpleTable-Header *:not(.sticky) > .SimpleTable-Titlebar .SimpleTable-Shortcuts span button.hide-icon i {
  display: none;
}
.SimpleTable .SimpleTable-Header .SimpleTable-Columns {
  display: flex;
  height: 45px;
  background: var(--bs-secondary-subtle);
  text-align: left;
  border-bottom: 2px solid rgba(0, 0, 0, 0.15);
}
.SimpleTable .SimpleTable-Header .SimpleTable-Columns,
.SimpleTable .SimpleTable-Header .SimpleTable-Columns .SimpleTable-Cell > .btn {
  text-transform: uppercase;
}
.SimpleTable .SimpleTable-Header .SimpleTable-Columns .fa,
.SimpleTable .SimpleTable-Header .SimpleTable-Columns .SimpleTable-Cell > .btn .fa {
  margin-top: -0.5rem;
}
.SimpleTable .SimpleTable-Header .SimpleTable-Columns .SimpleTable-Cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 100%;
}
.SimpleTable .SimpleTable-Header .SimpleTable-Columns .SimpleTable-Cell,
.SimpleTable .SimpleTable-Header .SimpleTable-Columns .SimpleTable-Cell *:not(i) {
  font-weight: 800 !important;
}
.SimpleTable .SimpleTable-Header .SimpleTable-Columns .SimpleTable-Cell[class*=SimpleTable-Cell-Sorted-] button {
  text-decoration: underline !important;
}
.SimpleTable .SimpleTable-Content {
  position: relative;
  margin-bottom: 4px;
}
.SimpleTable .SimpleTable-Columns,
.SimpleTable .SimpleTable-Content .SimpleTable-Body {
  position: relative;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row {
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 45px;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid var(--bs-gray-300);
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell {
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5rem;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell,
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell *:not(i),
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell *:not(i) {
  font-weight: bold;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell,
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell *,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell * {
  line-height: 1.1rem;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell input[type=checkbox],
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell input[type=checkbox] {
  width: 1.25rem;
  height: 1.25rem;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell button,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell button {
  border: none;
  background: transparent;
  padding: 0;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell:first-child,
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell + .SimpleTable-Cell,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell:first-child,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell + .SimpleTable-Cell {
  border-left: 1px solid var(--bs-gray-300);
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell:last-of-type,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell:last-of-type {
  border-right: 1px solid var(--bs-gray-300);
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell {
  /* Cell Width Classes */
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell.w-xs-fixed,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell.w-xs-fixed {
  flex: 0 0 2.5rem;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell.w-sm-fixed,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell.w-sm-fixed {
  flex: 0 0 4rem;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell.w-md-fixed,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell.w-md-fixed {
  flex: 0 0 5rem;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell.w-lg-fixed,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell.w-lg-fixed {
  flex: 0 0 6rem;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell.w-sm-grow,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell.w-sm-grow {
  flex-grow: 0.75;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell.w-md-grow,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell.w-md-grow {
  flex-grow: 1.5;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell.w-lg-grow,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell.w-lg-grow {
  flex-grow: 2;
}
.SimpleTable .SimpleTable-Columns .SimpleTable-Row .SimpleTable-Cell.w-xl-grow,
.SimpleTable .SimpleTable-Content .SimpleTable-Body .SimpleTable-Row .SimpleTable-Cell.w-xl-grow {
  flex-grow: 3;
}
.SimpleTable .SimpleTable-Body .SimpleTable-Row:hover:after {
  content: "";
  position: absolute;
  pointer-events: none;
  border-radius: var(--bs-border-radius-lg);
  z-index: 1;
  top: -4px;
  left: -4px;
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  border: 4px solid var(--bs-secondary);
}
.SimpleTable .SimpleTable-Controls {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: 0;
  min-height: 90px;
  width: 4rem;
  right: -4rem;
  gap: 0.5rem;
  pointer-events: none;
  align-items: center;
}
.SimpleTable .SimpleTable-Controls button {
  position: absolute;
  pointer-events: all;
}
.SimpleTable .SimpleTable-Controls button:first-of-type {
  top: 0.5rem;
}
.SimpleTable .SimpleTable-Controls button:last-of-type {
  bottom: 0.5rem;
}
.SimpleTable input[type=checkbox] {
  appearance: none;
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid var(--bs-gray-600);
  box-shadow: none !important;
  background-color: #fff;
  border-radius: 0.25rem;
  position: relative;
  outline: none;
  cursor: pointer;
}
.SimpleTable input[type=checkbox]:focus {
  outline: none;
}
.SimpleTable input[type=checkbox]:checked {
  background-color: var(--bs-secondary);
  border: 1px solid var(--bs-secondary);
}
.SimpleTable input[type=checkbox]:checked::after {
  content: "";
  position: absolute;
  top: 0;
  left: 4px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.SimpleTable .sticky {
  z-index: 25;
}
.SimpleTable .sticky .SimpleTable-Titlebar {
  margin-left: -4rem;
}
.SimpleTable .sticky .SimpleTable-Titlebar .SimpleTable-Title {
  visibility: hidden;
}
.SimpleTable .sticky .SimpleTable-Titlebar .SimpleTable-Shortcuts {
  pointer-events: none;
  position: absolute;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 4rem;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
}
.SimpleTable .sticky .SimpleTable-Titlebar .SimpleTable-Shortcuts span {
  pointer-events: all;
}
.SimpleTable .sticky .SimpleTable-Titlebar .SimpleTable-Shortcuts span button {
  pointer-events: all;
  width: 2.5rem;
  background-color: var(--bs-secondary-subtle);
  border: 1px solid rgb(108, 117, 125) !important;
  padding: 0.375rem 0.75rem !important;
}
.SimpleTable .sticky .SimpleTable-Titlebar .SimpleTable-Shortcuts span button span + span {
  display: none;
}
.SimpleTable .sticky .SimpleTable-Titlebar .SimpleTable-Shortcuts span button:active {
  box-shadow: 3px 4px 12px -2px rgba(0, 0, 0, 0.35) inset !important;
}
.SimpleTable .sticky .SimpleTable-Titlebar .SimpleTable-Shortcuts span button:disabled {
  pointer-events: none;
}

@media print {
  .SimpleTable .fa.fa-circle-info,
  .SimpleTable .SimpleTable-Shortcuts,
  .SimpleTable .SimpleTable-Controls,
  .SimpleTable .SimpleTable-Title {
    display: none;
  }
  .SimpleTable .SimpleTable-Columns {
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    border-right: 1px solid rgba(0, 0, 0, 0.15);
  }
  .SimpleTable .SimpleTable-Content {
    border-right: 1px solid rgba(0, 0, 0, 0.15);
  }
  .SimpleTable .SimpleTable-Row .SimpleTable-Cell {
    background-color: transparent !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SimpleTable/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AAEJ;AADI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAGN;AAFM;EACE,4CAAA;EACA,oBAAA;EACA,kCAAA;EACA,yBAAA;EACA,iBAAA;AAIR;AAAM;EACE,YAAA;AAER;AAAU;EACE,oBAAA;AAEZ;AAAc;EACE,aAAA;AAEhB;AAKI;EACE,aAAA;EACA,YAAA;EACA,sCAAA;EACA,gBAAA;EACA,4CAAA;AAHN;AAIM;;EAEE,yBAAA;AAFR;AAGQ;;EACE,mBAAA;AAAV;AAGM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AADR;AAEQ;;EAEE,2BAAA;AAAV;AAGU;EACE,qCAAA;AADZ;AAQE;EACE,kBAAA;EACA,kBAAA;AANJ;AASE;;EAEE,kBAAA;AAPJ;AAQI;;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,2CAAA;AALN;AAMM;;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAHR;AAIQ;;;;EAEE,iBAAA;AAAV;AAEQ;;;;EAEE,mBAAA;AAEV;AAAQ;;EACE,cAAA;EACA,eAAA;AAGV;AADQ;;EACE,YAAA;EACA,uBAAA;EACA,UAAA;AAIV;AAFQ;;;;EAEE,yCAAA;AAMV;AAJQ;;EACE,0CAAA;AAOV;AAvCM;;EAmCE,uBAAA;AAQR;AAPQ;;EACE,gBAAA;AAUV;AARQ;;EACE,cAAA;AAWV;AATQ;;EACE,cAAA;AAYV;AAVQ;;EACE,cAAA;AAaV;AAXQ;;EACE,eAAA;AAcV;AAZQ;;EACE,cAAA;AAeV;AAbQ;;EACE,YAAA;AAgBV;AAdQ;;EACE,YAAA;AAiBV;AATQ;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,yCAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;EACA,qCAAA;AAWV;AANE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,MAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AAQJ;AAPI;EACE,kBAAA;EACA,mBAAA;AASN;AARM;EACE,WAAA;AAUR;AARM;EACE,cAAA;AAUR;AANE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oCAAA;EACA,2BAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAQJ;AANI;EACE,aAAA;AAQN;AALI;EACE,qCAAA;EACA,qCAAA;AAON;AALM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;AAOR;AAHE;EACE,WAAA;AAKJ;AAJI;EACE,kBAAA;AAMN;AALM;EACE,kBAAA;AAOR;AALM;EACE,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAOR;AANQ;EACE,mBAAA;AAQV;AAPU;EACE,mBAAA;EACA,aAAA;EACA,4CAAA;EACA,+CAAA;EACA,oCAAA;AASZ;AARY;EACE,aAAA;AAUd;AARY;EACE,kEAAA;AAUd;AARY;EACE,oBAAA;AAUd;;AADA;EAEI;;;;IAIE,aAAA;EAGJ;EADE;IACE,yCAAA;IACA,2CAAA;EAGJ;EADE;IACE,2CAAA;EAGJ;EAAI;IACE,wCAAA;EAEN;AACF","sourcesContent":[".SimpleTable {\n  position: relative;\n  .SimpleTable-Header {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    .SimpleTable-Titlebar {\n      display: flex;\n      flex-direction: row;\n      gap: 0.5rem;\n      .SimpleTable-Title {\n        background-color: var(--bs-secondary-subtle);\n        padding: 0.5rem 1rem;\n        border-radius: 0.85rem 0.85rem 0 0;\n        text-transform: uppercase;\n        font-weight: bold;\n      }\n    }\n    *:not(.sticky) > .SimpleTable-Titlebar {\n      .SimpleTable-Shortcuts {\n        flex-grow: 1;\n        span {\n          button {\n            padding: 0.5rem 1rem;\n            &.hide-icon {\n              i {\n                display: none;\n              }\n            }\n          }\n        }\n      }\n    }\n    .SimpleTable-Columns {\n      display: flex;\n      height: 45px;\n      background: var(--bs-secondary-subtle);\n      text-align: left;\n      border-bottom: 2px solid rgba(0, 0, 0, 0.15);\n      &,\n      .SimpleTable-Cell > .btn {\n        text-transform: uppercase;\n        .fa {\n          margin-top: -0.5rem;\n        }\n      }\n      .SimpleTable-Cell {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-content: center;\n        height: 100%;\n        &,\n        *:not(i) {\n          font-weight: 800 !important;\n        }\n        &[class*='SimpleTable-Cell-Sorted-'] {\n          button {\n            text-decoration: underline !important;\n          }\n        }\n      }\n    }\n  }\n\n  .SimpleTable-Content {\n    position: relative;\n    margin-bottom: 4px;\n  }\n\n  .SimpleTable-Columns,\n  .SimpleTable-Content .SimpleTable-Body {\n    position: relative;\n    .SimpleTable-Row {\n      position: relative;\n      display: flex;\n      flex-direction: row;\n      width: 100%;\n      height: 45px;\n      align-items: center;\n      box-sizing: border-box;\n      border-bottom: 1px solid var(--bs-gray-300);\n      .SimpleTable-Cell {\n        height: 100%;\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 0 0.5rem;\n        &,\n        *:not(i) {\n          font-weight: bold;\n        }\n        &,\n        * {\n          line-height: 1.1rem;\n        }\n        input[type='checkbox'] {\n          width: 1.25rem;\n          height: 1.25rem;\n        }\n        button {\n          border: none;\n          background: transparent;\n          padding: 0;\n        }\n        &:first-child,\n        + .SimpleTable-Cell {\n          border-left: 1px solid var(--bs-gray-300);\n        }\n        &:last-of-type {\n          border-right: 1px solid var(--bs-gray-300);\n        }\n\n        /* Cell Width Classes */\n        &.w-xs-fixed {\n          flex: 0 0 2.5rem;\n        }\n        &.w-sm-fixed {\n          flex: 0 0 4rem;\n        }\n        &.w-md-fixed {\n          flex: 0 0 5rem;\n        }\n        &.w-lg-fixed {\n          flex: 0 0 6rem;\n        }\n        &.w-sm-grow {\n          flex-grow: 0.75;\n        }\n        &.w-md-grow {\n          flex-grow: 1.5;\n        }\n        &.w-lg-grow {\n          flex-grow: 2;\n        }\n        &.w-xl-grow {\n          flex-grow: 3;\n        }\n      }\n    }\n  }\n  .SimpleTable-Body {\n    .SimpleTable-Row {\n      &:hover {\n        &:after {\n          content: '';\n          position: absolute;\n          pointer-events: none;\n          border-radius: var(--bs-border-radius-lg);\n          z-index: 1;\n          top: -4px;\n          left: -4px;\n          width: calc(100% + 8px);\n          height: calc(100% + 8px);\n          border: 4px solid var(--bs-secondary);\n        }\n      }\n    }\n  }\n  .SimpleTable-Controls {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    top: 0;\n    min-height: 90px;\n    width: 4rem;\n    right: -4rem;\n    gap: 0.5rem;\n    pointer-events: none;\n    align-items: center;\n    button {\n      position: absolute;\n      pointer-events: all;\n      &:first-of-type {\n        top: 0.5rem;\n      }\n      &:last-of-type {\n        bottom: 0.5rem;\n      }\n    }\n  }\n  input[type='checkbox'] {\n    appearance: none;\n    width: 1.25rem;\n    height: 1.25rem;\n    border: 1px solid var(--bs-gray-600);\n    box-shadow: none !important;\n    background-color: #fff;\n    border-radius: 0.25rem;\n    position: relative;\n    outline: none;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:checked {\n      background-color: var(--bs-secondary);\n      border: 1px solid var(--bs-secondary);\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 4px;\n        width: 5px;\n        height: 10px;\n        border: solid #fff;\n        border-width: 0 2px 2px 0;\n        transform: rotate(45deg);\n      }\n    }\n  }\n  .sticky {\n    z-index: 25;\n    .SimpleTable-Titlebar {\n      margin-left: -4rem;\n      .SimpleTable-Title {\n        visibility: hidden;\n      }\n      .SimpleTable-Shortcuts {\n        pointer-events: none;\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        height: 100vh;\n        width: 4rem;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.5rem 0;\n        span {\n          pointer-events: all;\n          button {\n            pointer-events: all;\n            width: 2.5rem;\n            background-color: var(--bs-secondary-subtle);\n            border: 1px solid rgba(108, 117, 125, 1) !important;\n            padding: 0.375rem 0.75rem !important;\n            span + span {\n              display: none;\n            }\n            &:active {\n              box-shadow: 3px 4px 12px -2px rgba(0, 0, 0, 0.35) inset !important;\n            }\n            &:disabled {\n              pointer-events: none;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media print {\n  .SimpleTable {\n    .fa.fa-circle-info,\n    .SimpleTable-Shortcuts,\n    .SimpleTable-Controls,\n    .SimpleTable-Title {\n      display: none;\n    }\n    .SimpleTable-Columns {\n      border-top: 1px solid rgba(0, 0, 0, 0.15);\n      border-right: 1px solid rgba(0, 0, 0, 0.15);\n    }\n    .SimpleTable-Content {\n      border-right: 1px solid rgba(0, 0, 0, 0.15);\n    }\n    .SimpleTable-Row {\n      .SimpleTable-Cell {\n        background-color: transparent !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
